export default "__VITE_ASSET__DwRosUp0__"